import React, { FC, useState } from "react";
import {
  Table,
  Menu,
  Button,
  Dropdown,
  Popconfirm,
  TablePaginationConfig,
} from "antd";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

import getColumnSearchProps from "../Layout/Common/Adapters/TableFilter";
import useHttpGet from "../../hooks/useHttpGet";
import { IResultListResponse } from "../../models/response/result-list.model";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import BlogService from "../../services/blog.service";
import { PrivateUIRoutes } from "../../router";
import { IBlog } from "../../models/blog.model";
import { random } from "lodash";

const List: FC = () => {
  const [filter, setFilter] = useState({
    search: null,
    sortPropertyName: null,
    sortAscending: false,
    updateTrigger: 0
  });

  const [pagination, setPagination] = useState<any>({
    showSizeChanger: true,
    pageSizeOptions: ["30", "50", "100"],
    defaultPageSize: 30,
    pageSize: 30,
    current: 1,
    total: 1,
  });

  const { fetchedData, loading } = useHttpGet<IResultListResponse<IBlog>>(
    `${APIRoutes.BLOG}`,
    {
      dependencies: [filter, filter.updateTrigger],
      query: {
        ...filter,
        pageSize: pagination.pageSize,
        pageNumber: pagination.current - 1,
      },
      defaultValue: {} as IResultListResponse<IBlog>,
      reject: CommonService.showAllErrors,
      resolve: (response) => {
        setPagination({ ...pagination, total: response.result.totalElementsCount });
      }
    }
  );

  const handleTableChange = (
    newPagination: TablePaginationConfig,
    filters: any,
    sorter: any
  ) => {
    setPagination({ ...pagination, ...newPagination });

    const newFilter: any = { ...filter };

    newFilter.search = filters?.title?.length > 0 ? filters?.title[0] : null;

    if (!!sorter) {
      newFilter.sortPropertyName = sorter.field;
      newFilter.sortAscending = sorter?.order === "ascend";
    }

    setFilter(newFilter);
  };

  const menu = (record: IBlog) => (
    <Menu>
      <Menu.Item key="1">
        <Link
          className="c-blue"
          to={`/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.VIEW_BLOG_BASE}/${record?.id}`}
        >
          Edit
        </Link>
      </Menu.Item>

      <Menu.Item key="2">
        <Popconfirm
          title="Are you sure you want to delete this item?"
          onConfirm={() => { BlogService.delete(record.id); setFilter({ ...filter, updateTrigger: random() }); }}
          onCancel={() => { }}
          okText="Yes"
          cancelText="No"
        >
          Delete
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      sorter: true,
      ...getColumnSearchProps("title"),
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      sorter: true,
    },
    {
      title: "Watch Count",
      dataIndex: "watchCount",
      sorter: true,
    },
    {
      title: "",
      dataIndex: "id",
      render: (text: any, record: IBlog) => {
        return (
          <Dropdown overlay={menu(record)}>
            <Button>
              <MenuOutlined />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={fetchedData.result?.list || []}
      onChange={handleTableChange}
      pagination={pagination}
      rowKey="id"
      loading={loading}
      size="small"
    />
  );
};

export default List;
